import { Button, EditHollowSVG, ExternalLinkSVG } from "@newsela/angelou";
import { withTrackEvent } from "@newsela/snitch";
import PropTypes from "prop-types";

import { buttonCss, iconCss, rootCss, textCss } from "./FormativeBanner.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  data: PropTypes.object.isRequired,
  eventProperties: PropTypes.object,
};

const FormativeBanner = ({ data, eventProperties }) => {
  const labelText = "Edit and add quiz questions for free on";

  return (
    <form method="post" action={data.url} target="_blank">
      <input name="id_token" type="hidden" value={data.payload} />
      <div css={rootCss}>
        <EditHollowSVG css={iconCss} />
        <p css={textCss}>
          {labelText}&nbsp;
          <ButtonWithTrackEvent
            __cssFor={{ root: buttonCss }}
            ariaProps={{
              "aria-label": `${labelText} Formative. Opens in new tab`,
            }}
            dataProps={{ "data-qa-selector": "formative-activity-panel-link" }}
            icon={{
              SvgComponent: ExternalLinkSVG,
              alignment: Button.iconAlignments.right,
            }}
            flavor={Button.flavors.incognito}
            type="submit"
            {...eventProperties}
          >
            Formative.
          </ButtonWithTrackEvent>
        </p>
      </div>
    </form>
  );
};

FormativeBanner.propTypes = propTypes;

export default FormativeBanner;
